"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const cardImage_1 = __importDefault(require("../../../components/cardImage"));
const DraggableScroll_1 = __importDefault(require("../../../components/dragabbleScroll/DraggableScroll"));
const SectionTitle_1 = __importDefault(require("../../../components/sectionTitle/SectionTitle"));
const underline_1 = __importDefault(require("../../../components/underline"));
const mockData_1 = require("./mockData");
require("./SectionAmenities.scss");
const SectionAmenities = () => {
    const [suites, setSuites] = (0, react_1.useState)([]);
    const [condominiums, setCondominium] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const [respSuites, respDiffs] = yield Promise.all([(0, mockData_1.getDataMockSuites)(), (0, mockData_1.getDataMockDiffs)()]);
            setSuites(respSuites);
            setCondominium(respDiffs);
        }))();
    }, []);
    return (react_1.default.createElement("div", { className: "SectionAmenities" },
        react_1.default.createElement(SectionTitle_1.default, { text: "Comodidades e Instala\u00E7\u00F5es" }),
        react_1.default.createElement("div", { className: "underline-wrapper" },
            react_1.default.createElement(underline_1.default, null)),
        react_1.default.createElement("span", { className: "description" }, "Conte com o conforto das nossas su\u00EDtes mobiliadas e dos nossos condom\u00EDnios completos."),
        react_1.default.createElement("div", { className: "carousel-group" },
            react_1.default.createElement("div", { className: "group-title" },
                react_1.default.createElement("span", { className: "text" }, "Su\u00EDtes"),
                react_1.default.createElement("hr", { className: "text-spacer" })),
            react_1.default.createElement(DraggableScroll_1.default, null,
                react_1.default.createElement("div", { className: "hide-in-mobile" },
                    react_1.default.createElement(cardImage_1.default, { isEmpty: true }),
                    suites.map(({ imgUrl, text }) => (react_1.default.createElement(cardImage_1.default, { key: imgUrl },
                        react_1.default.createElement("img", { draggable: false, src: imgUrl, alt: text, className: "item-img" }),
                        react_1.default.createElement("span", { className: "item-text" }, text)))),
                    react_1.default.createElement(cardImage_1.default, { isEmpty: true }))),
            react_1.default.createElement("div", { className: "group-title" },
                react_1.default.createElement("span", { className: "text" }, "Condom\u00EDnios"),
                react_1.default.createElement("hr", { className: "text-spacer" })),
            react_1.default.createElement(DraggableScroll_1.default, null,
                react_1.default.createElement("div", { className: "hide-in-mobile" },
                    react_1.default.createElement(cardImage_1.default, { isEmpty: true }),
                    condominiums.map(({ imgUrl, text }) => (react_1.default.createElement(cardImage_1.default, { key: `condominiums${imgUrl}` },
                        react_1.default.createElement("img", { draggable: false, src: imgUrl, alt: text, className: "item-img" }),
                        react_1.default.createElement("span", { className: "item-text" }, text)))),
                    react_1.default.createElement(cardImage_1.default, { isEmpty: true }))))));
};
exports.default = SectionAmenities;
